import { Callout, Overlay } from '@blueprintjs/core'
import * as classnames from 'classnames/bind'
import * as firebase from 'firebase'
import * as i18n from 'i18next'
import * as React from 'react'
import { reactI18nextModule, withI18n } from 'react-i18next'
import { connect } from 'react-redux'
import { Dispatch, RootState } from 'src/store'
import utilsStyle from '../../utils.scss'
import buttonStyles from '../Button/button.scss'
import Icon from '../Icon'
import TextInput from '../TextInput'
import styles from './auth-modal.scss'

const cx = classnames.bind({ ...styles, ...buttonStyles, ...utilsStyle })

i18n
  .use(reactI18nextModule) // passes i18n down to react-i18next
  .init({
    resources: {
      'zh-TW': {
        translation: {
          /* register */
          'auth/account-exists-with-different-credential': '此帳號已註冊',
          'auth/email-already-in-use': '此帳號已註冊',
          'auth/invalid-email': '請輸入電子信箱',
          'auth/weak-password': '請輸入密碼至少6個字元',
          /* login */
          'auth/wrong-password': '帳號或密碼輸入錯誤',
          'auth/user-not-found': '此帳號尚未註冊',
          'auth/user-disabled': '此帳號已被停用 此帳號尚未驗證',
          'auth/unauthorized-domain': '此帳號已被停用 此帳號尚未驗證',
          'auth/null-user': '此帳號已被停用 此帳號尚未驗證',
          /* payment */
          'auth/timeout': '請登入後再繼續購買 登入已逾時，請重新登入',
          /* other */

          'auth/popup-closed-by-user': '使用者關閉訊息框'
        }
      }
    },
    lng: 'zh-TW',
    fallbackLng: 'zh-TW',
    interpolation: {
      escapeValue: false
    }
  })

interface IProps
  extends Partial<ReturnType<typeof mapState>>,
  Partial<ReturnType<typeof mapDispatch>> {
  active: boolean
  onCancel?: () => void
}

class AuthModal extends React.Component<IProps> {
  public state = {
    contentKey: 'login',
    forgotPassword: {
      loading: true,
      error: null
    }
  }
  public handleContentChange = (contentKey: string) => {
    this.setState({
      contentKey,
      forgotPassword: {
        loading: true,
        error: null
      }
    })
  }
  public handlePasswordReset = (event: React.FormEvent<HTMLFormElement>) => {
    this.setState({
      forgotPassword: {
        loading: true,
        error: null
      }
    })
    firebase
      .auth()
      .sendPasswordResetEmail(event.currentTarget.email.value)
      .then(_ =>
        this.setState({
          forgotPassword: {
            loading: false,
            error: null
          }
        })
      )
      .catch(e =>
        this.setState({
          forgotPassword: {
            loading: false,
            error: e.message
          }
        })
      )
    event.preventDefault()
  }
  public render() {
    let content

    const { contentKey } = this.state
    const { active, onCancel } = this.props
    switch (contentKey) {
      case 'login':
        content = this.loginContent()
        break
      case 'forgotPassword':
        content = this.forgotPasswordContent()
        break
      default:
        content = null
        break
    }
    const className = cx({
      modal: true,
      active
    })
    return (
      <Overlay className={className} isOpen={active} onClose={onCancel}>
        <div className={styles.modal__dialog}>{content}</div>
      </Overlay>
    )
  }
  public loginContent = () => {
    const { error, onFacebookClick, onGoogleClick, onRegisterClick, onCancel } = this.props
    return (
      <div className={styles.modal__content}>
        <div className={styles.modal__header}>
          <button className={cx('close')} onClick={onCancel}>
            <Icon type="popup-close" />
          </button>
          <h3 className={cx('title')}>登入註冊</h3>
        </div>
        <div className={styles.modal__body}>
          <a
            onClick={onFacebookClick}
            href="#!"
            className={cx(
              'btn',
              'btn--social-fb',
              'btn--lg',
              'btn--fluid',
              'u-mb-16'
            )}
          >
            Facebook 登入註冊
          </a>
          <a
            onClick={onGoogleClick}
            href="#!"
            className={cx(
              'btn',
              'btn--social-google',
              'btn--lg',
              'btn--fluid',
              'u-mb-16'
            )}
          >
            Google 登入註冊
          </a>
          <p className={cx('text-devided', 'u-pt-16', 'u-mb-32')}>
            <span>或者改用直接登入註冊</span>
          </p>
          <div className={styles.modal__errormessage__spacing}>
            {error ? (
              <Callout
                title={
                  i18n.exists(error.code) ? i18n.t(error.code) : error.message
                }
                intent="danger"
                icon="error"
              />
            ) : null}
          </div>
          <form action="" onSubmit={onRegisterClick}>
            <div className={cx('input--icon', 'u-mb-16')}>
              <TextInput
                name="email"
                type="text"
                placeholder="電子信箱"
                fluid={true}
              />
              <Icon className={cx('icon')} type="user" />
            </div>
            <div className={cx('input--icon', 'u-mb-16')}>
              <TextInput
                name="password"
                type="password"
                placeholder="密碼"
                fluid={true}
              />
              <Icon className={cx('icon')} type="password" />
            </div>
            <input
              className={cx(
                'btn',
                'btn--primary',
                'btn--lg',
                'btn--fluid',
                'u-mb-16'
              )}
              type="submit"
              value="登入註冊"
            />
          </form>
          <p
            className={cx('para', 'u-text-center', 'u-mb-16')}
            onClick={this.handleContentChange.bind(null, 'forgotPassword')}
          >
            忘記密碼
          </p>
        </div>
      </div>
    )
  }
  public forgotPasswordContent = () => {
    const { error, loading } = this.state.forgotPassword
    return (
      <div className={styles.modal__content}>
        <div className={styles.modal__header}>
          <button className={cx('close')} onClick={this.props.onCancel}>
            <Icon type="popup-close" />
          </button>
          <h3 className={cx('title')}>忘記密碼</h3>
        </div>
        <div className={styles.modal__body}>
          {loading ? null : error ? (
            <Callout title={error} intent="danger" icon="error" />
          ) : (
              <Callout
                title="已送出密碼重設信"
                intent="success"
                icon="info-sign"
              />
            )}
          <form action="" onSubmit={this.handlePasswordReset}>
            <div className={cx('input--icon', 'u-mb-16')}>
              <TextInput
                name="email"
                type="text"
                placeholder="電子信箱"
                fluid={true}
              />
              <Icon className={cx('icon')} type="user" />
            </div>
            <input
              className={cx(
                'btn',
                'btn--primary',
                'btn--lg',
                'btn--fluid',
                'u-mb-16'
              )}
              type="submit"
              value="確認"
            />
          </form>
          <p
            className={cx('para', 'u-text-center', 'u-mb-16')}
            onClick={this.handleContentChange.bind(null, 'login')}
          >
            登入註冊
          </p>
        </div>
      </div>
    )
  }
}

const mapState = ({ auth }: RootState) => ({
  error: auth.error
})

const mapDispatch = (dispatch: Dispatch) => ({
  onFacebookClick: () => dispatch.auth.signinWithFacebook(),
  onGoogleClick: () => dispatch.auth.signinWithGoogle(),
  onRegisterClick: (event: React.FormEvent<HTMLFormElement>) => {
    event.preventDefault()
    const { email, password } = event.currentTarget
    dispatch.auth.signinWithPassword({
      email: email.value,
      password: password.value
    })
  }
})

export default connect(
  mapState,
  mapDispatch
)(withI18n()(AuthModal))



// WEBPACK FOOTER //
// ./src/components/AuthModal/index.tsx